/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { useEffect, useState } from "react";
import { getNotifyPartyByIdApi } from "../../services/_notifyParty";

interface Props {
  notifyPartyId: string;
}

const ViewNotifyParty: React.FC<Props> = ({ notifyPartyId }) => {
  const [notifyParty, setNotifyParty] = useState<any>({});

  useEffect(() => {
    if (notifyPartyId) {
      setNotifyParty({});
      getNotifyPartyDetails();
    }
  }, [notifyPartyId]);

  const getNotifyPartyDetails = async () => {
    const result: any = await getNotifyPartyByIdApi(notifyPartyId as string);
    if (result.isSuccess) {
      setNotifyParty(result?.data);
    }
  };

  return (
    <div
      className="modal fade"
      id="viewProduct"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-simple modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body pt-0 pb-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="text-center">
              <h4 className="mb-0">Notify Party Details</h4>
            </div>
            <div className="info-container">
              <div className="pb-4 border-bottom text-capitalize mb-4"></div>
              <ul className="list-unstyled mb-6">
                <li className="mb-2">
                  <span className="h6 me-1">Name:</span>
                  <span>{notifyParty?.name}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Email:</span>
                  <span>{notifyParty?.email}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Phone No:</span>
                  <span>{notifyParty?.phone_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">PAN No:</span>
                  <span>{notifyParty?.pan_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">GST No:</span>
                  <span>{notifyParty?.gst_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">TAN No:</span>
                  <span>{notifyParty?.tan_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">UDHYAM No:</span>
                  <span>{notifyParty?.udhyam_no}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Address:</span>
                  <span>{notifyParty?.address}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">City:</span>
                  <span>{notifyParty?.city}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">State:</span>
                  <span>{notifyParty?.state}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Country:</span>
                  <span>{notifyParty?.country}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Pin Code:</span>
                  <span>{notifyParty?.pin_code}</span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Status:</span>
                  <span
                    className={`badge ${
                      notifyParty?.status
                        ? "bg-label-success"
                        : "bg-label-danger"
                    }`}
                  >
                    {notifyParty?.status ? "Active" : "Inactive"}
                  </span>
                </li>
                <li className="mb-2">
                  <span className="h6 me-1">Created At:</span>
                  <span>
                    {notifyParty?.created_at
                      ? moment(notifyParty?.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )
                      : ""}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewNotifyParty;
